import { environment } from '@lib/environment';
import { ImplicitFlow } from '@vacasa/react-components-lib';
import React from 'react';

export const EmployeeAuth: React.FC = ({ children }) => (
    <ImplicitFlow
        clientId={environment.REACT_APP_IDP_CLIENT_ID()}
        audience={environment.REACT_APP_API_AUDIENCE()}
        scopes={'employees:read'}
        env={environment.REACT_APP_IDP_ENV() as 'local' | 'dev' | 'stage' | 'prod'}
        redirectUrl={`${environment.REACT_APP_URL()}${'/login'}`}
        directoryHint="onelogin"
        tokenRefresh={true}
        followRedirect={true}
    >
        {children}
    </ImplicitFlow>
);
